import React from 'react';
import { useInternationalization } from '@progress/kendo-react-intl';

const StaticPropertyCell = ({ staticProperty, dataItem, field }) => {
  const intl = useInternationalization();

  let formatValue = dataItem[field];
  let className = '';

  if (formatValue && staticProperty.dataType === 'date') {
    formatValue = intl.toString(new Date(formatValue), 'd');
    className = 'alignment-right';
  }

  if (formatValue && (staticProperty.dataType === 'number' || staticProperty.dataType === 'percent')) {
    let format = staticProperty.dataType === 'percent' ? 'p' : 'n';
    formatValue = intl.toString(formatValue, `${format}${staticProperty.scale}`);
    className = 'alignment-right';
  }

  return (
    <td>
      <div className={className}>{formatValue}</div>
    </td>
  );
}

export default StaticPropertyCell;